import { defineMailTemplate } from '@adornis/mails/db/mail-template-definition.js';
import { config } from '@ils/config/config.js';
import { EmailAttachments, EmailType, EmailVars } from '@ils/mails/emailEnums.js';
import { html } from 'lit';
import { getProblemReportMailData } from '../server/resolver/mailData.js';

export const SlotCanceledMail = defineMailTemplate(EmailType.SLOT_CANCELED, {
  displayName: EmailType.SLOT_CANCELED,
  defaultTemplate: {
    subject: 'DRINGEND: Problem gemeldet',
    content: `
<p>Achtung es ist ein Problem aufgetreten!<br>Kümmern Sie sich unverzüglich um die Behebung oder kontaktieren Sie die technische Hilfe unter: ${config.get(
      'TECHNICALSUPPORTPHONE',
    )}</p>
<p>
Slotzeit: {{${EmailVars.SLOT_START_TIME}}}<br>
Prüfling: {{${EmailVars.FIRSTNAME}}} {{${EmailVars.LASTNAME}}}<br>
Schauspieler: {{${EmailVars.ACTOR_FULL_NAME}}}<br>
Examday ID: {{${EmailVars.EXAM_ID}}}<br>
Slot ID: {{${EmailVars.SLOT_ID}}}<br>
</p>
<p> {{${EmailVars.RAW_DATA}}} </p>
`,
    footer: '',
  },
  variables: [
    EmailVars.SLOT_START_TIME,
    EmailVars.FIRSTNAME,
    EmailVars.LASTNAME,
    EmailVars.SALUTATION,
    EmailVars.ACTOR_FULL_NAME,
    EmailVars.EXAM_ID,
    EmailVars.SLOT_ID,
    EmailVars.RAW_DATA,
  ],
  attachments: [EmailAttachments.INFO_PDF],
  editorHint: () => html`
    <p>
      Wird gesendet an:<br />
      - Alle Administratoren
    </p>
    <p>
      Wann:<br />
      - per Knopf als Prüfling während der laufenden Prüfung
    </p>
  `,
  getMailData: getProblemReportMailData,
});
